
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/catalogues",
      function () {
        return require("private-next-pages/catalogues.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/catalogues"])
      });
    }
  